export type CliLogVerbosity = 'info' | 'debug' | 'trace';

let verbosity: CliLogVerbosity = 'info';

export function setCliLogVerbosity(level: CliLogVerbosity): void {
  verbosity = level;
}

export function getCliLogVerbosity(): CliLogVerbosity {
  return verbosity;
}

export function isCliDebugOrTrace(): boolean {
  return verbosity === 'debug' || verbosity === 'trace';
}

export function isCliTrace(): boolean {
  return verbosity === 'trace';
}
